<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center" *ngIf="showLoading">
  Please wait we are initializing.....
</div>

<iframe [src]="url" height="700" width="95%"
        scrolling="no"></iframe>

<!--frameborder="0" style="border: 1px solid red;"-->

<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button kendoButton
          (click)="backToReview()"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Cancel
  </button>
  <!--<button kendoButton
          (click)="completeTxn()"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Complete Txn
  </button>-->
</div>
